module.exports = __webpack_public_path__ + "static/PricingBackground.505bba09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/PricingBackground.svg
// module id = ./src/assets/svgs/PricingBackground.svg
// module chunks = 129135808277484 226020273838829